export enum OrientationPurposeEnum {
  DOG_OBESITY = 17,
  CAT_OBESITY = 38,
  DOG_ASSISTED_NUTRITIONAL_SUPPORT = 44,
  CAT_ASSISTED_NUTRITIONAL_SUPPORT = 45
}
